<template>
  <BreadCrumb :items="breadcrumbItems" />
  <main id="main">
    <WeddingInvitationForm />
  </main>
</template>
<script>
import WeddingInvitationForm from '@/components/wedding/WeddingInvitationForm.vue';
import BreadCrumb from "../layout/navigation/BreadCrumb.vue";

export default {
  data() {
    return {
      breadcrumbItems: [
        { href: "/", text: "홈", isHome: true },
        { href: "#", text: "청첩장" },
      ],
    };
  },
  components: {
    BreadCrumb,
    WeddingInvitationForm
  }
}
</script>
<style>
    
</style>